<i *ngIf="!isAnonymous" class="fa-star favourite-icon" [ngClass]="isFavourite ? 'fas' : 'far'"></i>
